export interface UxErrorEvent {
    originalError: Event;
}
